export function getTubeTypes() {
  const tubes = ['Globe Scientific', 'MTC Bio', 'Vitrolife', 'Other'];

  const tubesList = [
    { value: '0', label: '--Select Tube Type--' },
    ...tubes.map((tube) => ({ value: tube, label: tube })),
  ];

  return tubesList;
}

export const isMilitaryTime = (time: string): boolean => {
  if (!time || typeof time !== 'string') return false;
  const cleanTime = time.trim();
  if (cleanTime.length !== 4) return false;
  return /^\d{4}$/.test(cleanTime);
};

export const convertToMilitaryTime = (time: string): string => {
  try {
    if (!time) return '';
    if (isMilitaryTime(time)) {
      return time;
    }
    const [timePart, period] = time.split(' ');
    if (!timePart || !period) {
      throw new Error('Invalid time format');
    }

    let [hours, minutes] = timePart
      .split(':')
      .map((part) => parseInt(part, 10));

    if (period.toLowerCase() === 'pm' && hours !== 12) {
      minutes += 0;
      hours += 12;
    } else if (period.toLowerCase() === 'am' && hours === 12) {
      hours = 0;
    }

    const militaryHours = hours.toString().padStart(2, '0');
    const militaryMinutes = minutes.toString().padStart(2, '0');

    return `${militaryHours}${militaryMinutes}`;
  } catch (error) {
    console.error('Error converting time:', error);
    return '';
  }
};
